var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"count-down"},[_vm._v(_vm._s(_vm.isShowHour || _vm.hour ? _vm.hourString + ':' + _vm.minuteString + ':' + _vm.secondString : _vm.minuteString + ':' + _vm.secondString))])}
var staticRenderFns = []

export { render, staticRenderFns }